import React from 'react';

const tagColorMap = {
  "MEGA SMASH": "#0095e0",
  "SMASH": "#2e7d32",
  "LEAN OVER": "#8e24aa",
  "MEGA FADE": "#b71c1c",
  "FADE": "#ef6c00",
  "LEAN UNDER": "#f9a825",
  "COIN TOSS": "#90a4ae",
};

const tagExplanations = [
  { tag: 'MEGA SMASH', description: 'Our strongest tag. Backed by compelling stats, trends, and matchup insights. Not a guarantee — but signals a high-conviction edge.' },
  { tag: 'SMASH', description: 'Very solid play. Above average stats and matchup. Worth serious consideration.' },
  { tag: 'LEAN OVER', description: 'Slight edge to going over. Some metrics in favor, but not dominant.' },
  { tag: 'COIN TOSS', description: '50/50 play. Could go either way based on trend, usage, or risk.' },
  { tag: 'LEAN UNDER', description: 'Slight edge to the under. Fewer supporting stats. Mild fade territory.' },
  { tag: 'FADE', description: 'We recommend avoiding this one. Data and matchup do not support success.' },
  { tag: 'MEGA FADE', description: 'Strong avoid. Everything says back away from this pick.' },
];

const TagHelpModal = ({ onClose, darkMode }) => {
  const modalStyles = {
    ...styles.modal,
    backgroundColor: darkMode ? '#121212' : '#fff',
    color: darkMode ? '#fff' : '#000',
  };

  const introStyles = {
    ...styles.intro,
    color: darkMode ? '#ccc' : '#555'
  };

  const disclaimerStyles = {
    ...styles.disclaimer,
    color: darkMode ? '#aaa' : '#666'
  };

  return (
    <div style={styles.overlay}>
      <div style={modalStyles}>
        <h2 style={styles.header}>What Do These Tags Mean?</h2>
        <p style={introStyles}>
          PlaysWithGuru analyzes performance, matchups, momentum, and context to label each prop with a tag. Here's what each tag means:
        </p>
        <ul style={styles.list}>
          {tagExplanations.map(({ tag, description }) => (
            <li key={tag} style={styles.item}>
              <span style={{ ...styles.tagBadge, backgroundColor: tagColorMap[tag] }}>{tag}</span>
              {description}
            </li>
          ))}
        </ul>
        <button onClick={onClose} style={styles.button}>Got It</button>
        <p style={disclaimerStyles}>
          ⚠️ <em>Disclaimer:</em> PlaysWithGuru is an independent data analytics platform created to help users make informed decisions across various domains. We do not promote or encourage gambling. All insights are provided for informational purposes only, should be used at your own discretion, and do not guarantee outcomes. While we strive for accuracy, data may contain occasional errors or inconsistencies. Users are encouraged to verify information independently.
        </p>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: 'fixed',
    top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.6)',
    display: 'flex', justifyContent: 'center', alignItems: 'center',
    zIndex: 1000,
    padding: 16,
  },
  modal: {
    borderRadius: 12,
    padding: '24px 20px',
    maxWidth: 600,
    width: '100%',
    maxHeight: '80vh',
    overflowY: 'auto',
    textAlign: 'left',
    boxShadow: '0 8px 16px rgba(0,0,0,0.2)',
  },
  header: {
    fontSize: 'clamp(18px, 4vw, 24px)',
    marginBottom: 12,
  },
  intro: {
    fontSize: 'clamp(13px, 3vw, 16px)',
    marginBottom: 16,
  },
  list: {
    listStyleType: 'none',
    padding: 0,
    marginBottom: 20,
  },
  item: {
    fontSize: 'clamp(14px, 3.2vw, 16px)',
    marginBottom: 12,
    display: 'flex',
    alignItems: 'center',
    gap: 8
  },
  tagBadge: {
    display: 'inline-block',
    minWidth: 100,
    padding: '6px 12px',
    borderRadius: 12,
    color: '#fff',
    fontWeight: 600,
    textAlign: 'center',
    fontSize: 'clamp(13px, 2.5vw, 14px)',
  },
  button: {
    backgroundColor: '#0276aa',
    color: '#fff',
    padding: '12px 18px',
    border: 'none',
    borderRadius: 8,
    cursor: 'pointer',
    fontWeight: 'bold',
    fontSize: 'clamp(14px, 4vw, 16px)'
  },
  disclaimer: {
    marginTop: 20,
    fontSize: 'clamp(11px, 2.5vw, 13px)',
    fontStyle: 'italic',
    lineHeight: 1.5
  }
};

export default TagHelpModal;
